const CSS_CLASSES = {
	TOGGLE: 'toggle',
};

export { CSS_CLASSES };
